/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowCollapseCVOpenIcon16Light } from './ArrowCollapseCVOpenIcon16Light';
import { ArrowCollapseCVOpenIcon16Regular } from './ArrowCollapseCVOpenIcon16Regular';
import { ArrowCollapseCVOpenIcon16Solid } from './ArrowCollapseCVOpenIcon16Solid';
import { ArrowCollapseCVOpenIcon20Light } from './ArrowCollapseCVOpenIcon20Light';
import { ArrowCollapseCVOpenIcon20Regular } from './ArrowCollapseCVOpenIcon20Regular';
import { ArrowCollapseCVOpenIcon20Solid } from './ArrowCollapseCVOpenIcon20Solid';
import { ArrowCollapseCVOpenIcon24Regular } from './ArrowCollapseCVOpenIcon24Regular';
import { ArrowCollapseCVOpenIcon24Solid } from './ArrowCollapseCVOpenIcon24Solid';
import { ArrowCollapseCVOpenIcon32Regular } from './ArrowCollapseCVOpenIcon32Regular';
import { ArrowCollapseCVOpenIcon64Regular } from './ArrowCollapseCVOpenIcon64Regular';
var sizes = {
    16: {
        light: ArrowCollapseCVOpenIcon16Light,
        regular: ArrowCollapseCVOpenIcon16Regular,
        solid: ArrowCollapseCVOpenIcon16Solid,
    },
    20: {
        light: ArrowCollapseCVOpenIcon20Light,
        regular: ArrowCollapseCVOpenIcon20Regular,
        solid: ArrowCollapseCVOpenIcon20Solid,
    },
    24: {
        regular: ArrowCollapseCVOpenIcon24Regular,
        solid: ArrowCollapseCVOpenIcon24Solid,
    },
    32: {
        regular: ArrowCollapseCVOpenIcon32Regular,
    },
    64: {
        regular: ArrowCollapseCVOpenIcon64Regular,
    },
};
export var ArrowCollapseCVOpenIcon = forwardRef('ArrowCollapseCVOpenIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
